import { useSearchBoxItems } from 'hooks/api/box';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export function useFetchSubmissionFiles(enabled = true) {
  const { partialSubmission } = useSubmissionsWorkspace();

  return useSearchBoxItems({
    filter: { chunkSize: 20, folderId: partialSubmission?.boxFolderId! },
    enabled: enabled && !!partialSubmission?.boxFolderId,
  });
}
